import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Button } from '@ipc/ipc-components';
import { Link } from '@ipc/ipc-core';
import ListTable from '../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../common/tables/actions/ListTableActions';
import {
  getColumns,
  getData,
  getIsLoading,
} from '../redux/selectors/EdiRfidAuditRequestExecutionReportSelectors';
import { getAssetType } from '../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import DownloadTypes from '../../../../../common/tables/excel/DownloadTypes';
import {
  postDailyRouteLeadingCountUseEdiRequestActionCreator,
  postDailyRouteLeadingCountUseMaxRequestActionCreator,
} from '../../../../daily-route-leading-count-status/use-edi-or-max/redux/actions/DailyRouteLeadingCountUseEdiOrUseMaxActions';

class EdiRfidAuditRequestExecutionReportContainer extends Component {
  constructor(props) {
    super(props);
    this.props.tableLoadData(
      { tableId: TableDefinitions.EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT.id },
      this.props.appContext.appContext,
      {
        impcFromList: props.location.data.original.outboundImpcs,
        impcToList: props.location.data.original.inboundImpcs,
        startDate: moment(props.location.data.original.reportingStartDate).format('YYYY-MM-DD'),
        endDate: moment(props.location.data.original.reportingEndDate).format('YYYY-MM-DD'),
      },
    );
  }

  onClickCell = (state, rowInfo) => {
    if (rowInfo && rowInfo.row) {
      return {
        onClick: (e, handleOriginal) => {
          if (handleOriginal) {
            if (e.currentTarget.textContent === 'Use EDI') {
              this.props.postDailyRouteLeadingCountUseEdiRequestActionCreator(rowInfo.row.assetRouteId, rowInfo.row.date);
              this.props.tableLoadData(
                { tableId: TableDefinitions.EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT.id },
                this.props.appContext.appContext,
                {
                  impcFromList: this.props.location.data.original.outboundImpcs,
                  impcToList: this.props.location.data.original.inboundImpcs,
                  startDate: moment(this.props.location.data.original.reportingStartDate).format('YYYY-MM-DD'),
                  endDate: moment(this.props.location.data.original.reportingEndDate).format('YYYY-MM-DD'),
                },
              );
            } else if (e.currentTarget.textContent === 'Use Max') {
              this.props.postDailyRouteLeadingCountUseMaxRequestActionCreator(rowInfo.row.assetRouteId, rowInfo.row.date);
              this.props.tableLoadData(
                { tableId: TableDefinitions.EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT.id },
                this.props.appContext.appContext,
                {
                  impcFromList: this.props.location.data.original.outboundImpcs,
                  impcToList: this.props.location.data.original.inboundImpcs,
                  startDate: moment(this.props.location.data.original.reportingStartDate).format('YYYY-MM-DD'),
                  endDate: moment(this.props.location.data.original.reportingEndDate).format('YYYY-MM-DD'),
                },
              );
            }
          }
        },
      };
    }
    return {};
  };

  render() {
    return (
      <div className="general-content-container" style={{ flexDirection: 'column' }}>
        <h1 className="title-div">EDI-RFID Audit Result Report</h1>
        <div className="full-width">
          <div className="list-table-container">
            <ListTable
              listId={TableDefinitions.EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT.id}
              loading={this.props.isLoading}
              columns={this.props.columns}
              data={this.props.data}
              keyField="id"
              selectCheckbox
              downloadType={DownloadTypes.EXCEL}
              getTdProps={this.onClickCell}
            />
          </div>
          <div style={{ marginLeft: '30px' }}>
            <Link to={{ pathname: 'edi-rfid-audit' }}>
              <Button className="action-buttons" style={{ flexDirection: 'column' }}>
                Back
              </Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

EdiRfidAuditRequestExecutionReportContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  tableLoadData: PropTypes.func,
  appContext: PropTypes.objectOf(PropTypes.string),
  isLoading: PropTypes.bool,
  location: PropTypes.objectOf(PropTypes.shape),
  postDailyRouteLeadingCountUseEdiRequestActionCreator: PropTypes.func,
  postDailyRouteLeadingCountUseMaxRequestActionCreator: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  postDailyRouteLeadingCountUseEdiRequestActionCreator,
  postDailyRouteLeadingCountUseMaxRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EdiRfidAuditRequestExecutionReportContainer);
